module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/项目配图2.ae555f4c.png";